import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  incrementBasketAmount,
  decrementBasketAmount,
  removeFromCart,
  setCart,
  setRegistrationModal,
  setAmount,
} from "../../../../../redux/reducers";
import { getCartState, getIsAuth } from "../../../../../redux/selectors";
import styles from "./index.module.scss";
import useLocalStorageList from "../../../../../utils/hooks/useLocalStorageList";

const Layout = () => {
  const isAuth = useAppSelector((state) => getIsAuth(state));
  const dispatch = useAppDispatch();
  const [cost, setCost] = useState(0);
  const cart = useAppSelector((state) => getCartState(state));
  const counter = () => {
    let temp = 0;
    cart.forEach((e: any) => {
      temp += e.price * e.amount;
    });
    setCost(temp);
  };

  useEffect(() => {
    counter();
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  return (
    <div className={"container" + " " + styles.container}>
      <Table className={styles.table}>
        <thead>
          <tr className={styles.table_header}>
            <th>Товар</th>
            <th>Примичание</th>
            <th>Количество, шт.</th>
            <th>Стоимость, &#8381;</th>
          </tr>
        </thead>
        <tbody className={styles.body}>
          {cart.map((x: any, i) => (
            <Row
              key={i}
              amount={x.amount}
              catalogType={x.catalogType}
              detailName={x.detailName}
              price={x.price}
              id={x.id}
              vinNumber={x.vinNumber}
            />
          ))}
        </tbody>
        <tfoot>
          <tr className={styles.table_footer}>
            <th>
              {isAuth ? (
                <button>
                  Оформить <span> Заказ</span>
                </button>
              ) : (
                <button onClick={() => dispatch(setRegistrationModal())}>
                  Зарегестрируйтесь чтобы оформить<span> заказ</span>
                </button>
              )}
            </th>
            <th className={styles.footer_item}>Итого</th>
            <th className={styles.footer_item}>{cost}</th>
            <th></th>
            <th className={styles.hiden}>
              <div className={styles.footer_item}>Итого</div>
              <div className={styles.footer_item}>{cost}</div>
            </th>
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

const Row = ({
  amount,
  catalogType,
  detailName,
  price,
  id,
  vinNumber,
}: any) => {
  const dispatch = useAppDispatch();
  const cart = useAppSelector((state) => getCartState(state));

  return (
    <tr className={styles.row}>
      <th>{detailName}</th>
      <th>{catalogType}</th>
      <th>
        <button
          disabled={amount == 1 ? true : false}
          onClick={() => {
            dispatch(decrementBasketAmount(id));
          }}
        >
          -
        </button>
        <input
          value={amount}
          type="number"
          onChange={(e) => {
            console.log(Number(e.target.value));
            dispatch(setAmount({ id, newAmount: Number(e.target.value) }));
          }}
          name=""
          id=""
        />
        <button
          onClick={() => {
            dispatch(incrementBasketAmount(id));
          }}
        >
          +
        </button>
      </th>
      <th className={styles.price}>
        {price * amount}{" "}
        <span
          onClick={() => {
            dispatch(removeFromCart(id));
            if (cart.length == 1) {
              localStorage.removeItem("cart");
            }
          }}
          className={styles.delete}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </th>
    </tr>
  );
};

export default Layout;
